import { ButtonEmpty } from '@tallink/components-lib'
import { mediaQueries } from '@tallink/components-lib/src/constants/media'
import * as PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useMedia } from 'react-use'

import { addVoucher, removeVoucher } from '../../actions/actions'
import { getAddedVouchers, hasVouchers } from '../../selectors/selectors'
import AddNewVoucher from './AddNewVoucher/AddNewVoucher'
import VoucherEntry from './VoucherEntry/VoucherEntry'
import s from './VoucherPanel.module.scss'

export default function VoucherPanel({ onCancelAddNewVoucher, onRemoveLastVoucher = () => {} }) {
  const { t } = useTranslation()
  const smUp = useMedia(mediaQueries.smUp, true)

  const dispatch = useDispatch()
  const addedVouchers = useSelector(getAddedVouchers)
  const hasAddedVouchers = useSelector(hasVouchers)

  const [addVoucherFormVisible, setAddVoucherFormVisible] = useState(true)

  useEffect(() => {
    if (!smUp && !hasAddedVouchers) {
      setAddVoucherFormVisible(true)
    }
  }, [hasAddedVouchers, smUp])

  return (
    <div className={s['voucher-panel']}>
      <div className={s.header}>{t('voucherPanel.header')}</div>
      <div className={s.list}>
        {addedVouchers.map((voucher, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <VoucherEntry key={index} onRemoveVoucher={() => removeAddedVoucher(voucher)} voucher={voucher} />
        ))}
      </div>
      {addVoucherFormVisible && (
        <AddNewVoucher onAddVoucher={addNewVoucher} onCancelAddNewVoucher={cancelAddNewVoucher} />
      )}
      {hasAddedVouchers && !addVoucherFormVisible && (
        <ButtonEmpty className={s.link} onClick={startAddNewVoucher}>
          {t('voucherPanel.link.addAnotherVoucher')}
        </ButtonEmpty>
      )}
    </div>
  )

  function addNewVoucher(voucher) {
    dispatch(addVoucher(voucher))
    setAddVoucherFormVisible(false)
  }

  function removeAddedVoucher(voucher) {
    dispatch(removeVoucher(voucher))
    if (addedVouchers.length === 1) {
      onRemoveLastVoucher()
    }
  }

  function startAddNewVoucher() {
    setAddVoucherFormVisible(true)
  }

  function cancelAddNewVoucher() {
    onCancelAddNewVoucher()
    setAddVoucherFormVisible(false)
  }
}

VoucherPanel.propTypes = {
  onCancelAddNewVoucher: PropTypes.func.isRequired,
  onRemoveLastVoucher: PropTypes.func
}
